import { find, indexOf } from "lodash";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import KycApplicationContext from "../../Context/KYCApplicationContext/KYCApplicationContext";
import { ApplicationStatusEnum } from "../../Enumeration/ApplicationStatusEnum";
import { ProfileStatusTypeEnum } from "../../Enumeration/ProfileStatusTypeEnum";
import { VideoKYCStatusEnum } from "../../Enumeration/VideoKYCStatusEnum";
import SampleData from "../../Sample.json";
import ActionEnum from "../../Store/ActionEnum";
import * as widgetAction from "../../Store/WidgetActionCreator";
import { getIsKycProcessCompleted } from "../../Store/WidgetDataSelector";
import { WidgetEnum } from "../../Store/WidgetEnum";
import ApplicationDataHelper from "../../Utils/ApplicationDataHelper";
import { keyPersonalInfo, NONE, OK, VIEW_MODE } from "../../Utils/GlobalValues";
import useStaticData from "../CsplControls/CsplAch/UseStaticData";
import CsplLabel from "../CsplControls/CsplLabel/CsplLabel";
import CsplBackDropLoading from "../CsplControls/CsplLoader/CsplBackDropLoading";
import AlertModal from "../CsplModal/AlertModal";
import { AlertResponseEnum } from "../CsplModal/AlertResponse";
import CsplAlertModal from "../CsplModal/CsplAlertModal";
import WidgetChangeAlertModal from "../CsplModal/WidgetChangeAlertModal";
import KycGuideModal from "../KycGuide/KycGuideModal";
import OtpModal from "../OtpModal";
import RegistrationResource from "../Resources/CommonResources/RegistrationResource";
import Support from "../Support/Support";
import { useWidgetService } from "../Widgets/WidgetManager/UseWidgetService";
import Holder from "../Workflow/Holder";
import { SessionKeyEnum } from "./../../Enumeration/SessionKeyEnum";
import WidgetManager from "./../Widgets/WidgetManager/WidgetManager";
import Banner from "./Banner";
import { Content, SideBar } from "./Layout";

function MainAppLayout() {
  const applicationContext = useContext(KycApplicationContext);
  const [TACChecked, setTACChecked] = useState(true);
  const {
    getNavigationDetails,
    getNavigationDetailsFromDB,
    checkAadhaarXmlProfileStatus,
    getCKYCDetails,
    getAadharDetails,
    verifyOTP,
    resendOTP,
  } = RegistrationResource();
  const [isLoadingData, setIsLoadingData] = useState(true);

  const dispatch = useDispatch();
  const [currentFormData, setCurrentFormData] = useState();
  const { saveWidgetDataToDraft, dispatchApplicationDetailsToStore } =
    useWidgetService();
  const [widgetList, setWidgetList] = useState();
  const [showLoading, setShowLoading] = useState(false);
  const [isWidgetAlertOpen, setIsWidgetAlertOpen] = useState(false);
  const [moveToWidgetOrHolder, setMoveToWidgetOrHolder] = useState(null);
  const [lastChangedType, setLastChangedType] = useState();
  const disableForm = applicationContext.disableForm;
  const [isShowWidgetAlert, setIsShowWidgetAlert] = useState(false);
  const [applicationDTO, setApplicationDTO] = useState();
  const [widgetMessageToShow, setWidgetMessageToShow] = useState("");
  const [buttonText, setButtonText] = useState("PROCEED");

  //added for button loading
  const [isButtonDisable, setIsButtonDisable] = useState(false);

  const alertNotRequiredWidgetList = [
    WidgetEnum.PVIEWCKYC,
    WidgetEnum.VIDEOKYC,
    WidgetEnum.ESIGNTC,
  ];
  const [showKYCApplicationExpired, setShowKYCApplicationExpired] =
    useState(false);
  const [expiredKYCApplication, setExpiredKYCApplication] = useState({});
  const { t } = useTranslation("common");
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);
  const [isLookupProcessing, getLookupData] = useStaticData();
  const [triggerCkycOtpResponse, setTriggerCkycOtpResponse] = useState({});

  const [clicked, setClicked] = useState(false);
  const [isCkycFlow, setCkycFlow] = useState(false);
  const [modalVisible, setModalVisible] = useState(true);
  const [showCsplAlertModal, setShowCsplAlertModal] = useState(false);
  const [dynamicMessage, setDynamicMessage] = useState("");
  const [switchHolderWithoutSave, setSwitchHolderWithoutSave] = useState(false);
  const [isCkycValueFetch, setCkycValueFetch] = useState(false);
  const [isFHJourneyEmpty, setisFHJourneyEmpty] = useState(false);
  const [isSHJourneyEmpty, setisSHJourneyEmpty] = useState(false);
  const [otpMessage, setOtpMessage] = useState("");
  const [otpMessageType, setOtpMessageType] = useState("");
  const [InitialCkycTrigger, setInitialCkycTrigger] = useState(false);

  let isKycProcessCompleted = useSelector((state) =>
    getIsKycProcessCompleted(state),
  );

  /**
   * call auto trigger ckyc at initial
   * @param {} value
   */
  function getAutoTriggerConfirmation(value) {
    setInitialCkycTrigger(value);
  }

  /** set the Application details only if the application is not rejected in entry mode **/
  function setKYCApplicationDetails(res) {
    if (res) {
      if (
        res.mode !== VIEW_MODE &&
        res.status === ApplicationStatusEnum.Rejected
      ) {
        setShowKYCApplicationExpired(true);
        setExpiredKYCApplication(res);
        setIsLoadingData(false);
        setClicked(false);
      } else {
        setDefaultHolderAndWidget();
        setApplicationDTO(res);
        //dispatchApplicationDetailsToStore(res);
        // if(applicationContext.currentHolder && applicationContext.currentHolder.entityTypeShortName){
        //     applicationContext.setMoveToHolder(applicationContext.currentHolder.entityTypeShortName);
        // }
        //dispatchApplicationDetailsToStore(res);
        if (
          applicationContext.currentHolder &&
          applicationContext.currentHolder.entityTypeShortName
        ) {
          applicationContext.setMoveToHolder(
            applicationContext.currentHolder.entityTypeShortName,
          );
        }
        //update the application dto
        let saveWidgetPromise = new Promise(function (onSuccess, onError) {
          dispatchApplicationDetailsToStore(res);
          onSuccess();
        });

        setIsLoadingData(false);
        setClicked(false);
        setTermsAndConditionsState(res);
        showThankYouMessage(
          sessionStorage.getItem(SessionKeyEnum.ProfileStatusType),
          res,
        );
        sessionStorage.setItem(SessionKeyEnum.ProfileStatusType, "");
        setInitialLoadingSetupBasedOnkycApplicationWorkflow(res);
      }
    }
  }

  function generateNavigationDetailDTO() {
    const navigationDetailDTO = {
      appKey: sessionStorage.getItem(SessionKeyEnum.AppKey),
      encryptedMode: sessionStorage.getItem(SessionKeyEnum.EncryptedMode),
      profileId: sessionStorage.getItem(SessionKeyEnum.ProfileId),
      profileStatusType: sessionStorage.getItem(
        SessionKeyEnum.ProfileStatusType,
      ),
      holderType: sessionStorage.getItem(SessionKeyEnum.HolderType),
    };
    return navigationDetailDTO;
  }

  /** get navigation details from idfy */
  function getNavigationDetailsFromIDFY() {
    return getNavigationDetails(generateNavigationDetailDTO()).then(
      (res) => {
        sessionStorage.setItem(
          SessionKeyEnum.KycApplicationId,
          res.kycApplicationId,
        );
        setKYCApplicationDetails(res);
        return res;
      },
      (error) => {
        sessionStorage.setItem(SessionKeyEnum.KycApplicationId, null);
        setIsLoadingData(false);
        setClicked(false);

        dispatch(
          widgetAction.createAction(
            ActionEnum.UPDATE_HOLDER_LIST,
            SampleData.kycApplicationEntityDTOList,
          ),
        );
      },
    );
  }

  /** get navigation details from db */
  function getNavigationDetailsFromDataBase() {
    return getNavigationDetailsFromDB(generateNavigationDetailDTO()).then(
      (res) => {
        sessionStorage.setItem(
          SessionKeyEnum.KycApplicationId,
          res.kycApplicationId,
        );
        setKYCApplicationDetails(res);
        return res;
      },
      (error) => {
        sessionStorage.setItem(SessionKeyEnum.KycApplicationId, null);
        setIsLoadingData(false);
        setClicked(false);

        dispatch(
          widgetAction.createAction(
            ActionEnum.UPDATE_HOLDER_LIST,
            SampleData.kycApplicationEntityDTOList,
          ),
        );
      },
    );
  }

  /** based on the session details fetch the application details */
  const getApplicationDetails = async () => {
    setExpiredKYCApplication({});
    sessionStorage.setItem(SessionKeyEnum.KycApplicationId, null);
    await new Promise((resolve) => setTimeout(resolve, 5000));

    const aadhaarProfileStatus = await checkAadhaarXmlProfileStatus(
      generateNavigationDetailDTO(),
    );

    if (aadhaarProfileStatus) {
      return await getNavigationDetailsFromDataBase();
    } else {
      return await getNavigationDetailsFromIDFY();
    }
  };

  /**
   * set the default holder and widget
   * @param {string}  holderType
   * @param {string} profileStatusType
   */
  function setDefaultHolderAndWidget() {
    let profileStatusType = sessionStorage.getItem(
      SessionKeyEnum.ProfileStatusType,
    );
    if (profileStatusType && profileStatusType != keyPersonalInfo) {
      setDefaultHolder(sessionStorage.getItem(SessionKeyEnum.HolderType));
      setDefaultWidget(
        sessionStorage.getItem(SessionKeyEnum.ProfileStatusType),
      );
    } else if (profileStatusType && profileStatusType == keyPersonalInfo) {
      setDefaultHolder(sessionStorage.getItem(SessionKeyEnum.HolderType));
      setDefaultWidget(WidgetEnum.PERSONALINFO);
    }
  }

  /**
   * Set the default holder
   * @param {string} holderType
   */
  function setDefaultHolder(holderType) {
    if (holderType) {
      applicationContext.setMoveToHolder(holderType);
    }
  }

  /**
   * Based on the profile status type set widget name
   * @param {string}  profileStatusType
   */
  function setDefaultWidget(profileStatusType) {
    if (profileStatusType === ProfileStatusTypeEnum.Video) {
      applicationContext.setWidgetShortNameToShow(WidgetEnum.VIDEOKYC);
    } else if (profileStatusType === ProfileStatusTypeEnum.Aadhar) {
      applicationContext.setWidgetShortNameToShow(WidgetEnum.PERSONALINFO);
    } else if (profileStatusType === ProfileStatusTypeEnum.ESign) {
      applicationContext.setWidgetShortNameToShow(WidgetEnum.ESIGNTC);
    }
  }

  function setTermsAndConditionsState(applicationDTO) {
    if (applicationDTO != null && applicationDTO !== "" && !disableForm) {
      setTACChecked(applicationDTO.kycTcAccepted);
    }
  }

  /**
   * check and set FH and SH journey started or not
   * @param {*} result
   */
  function setInitialLoadingSetupBasedOnkycApplicationWorkflow(result) {
    const entityList = result.kycApplicationEntityDTOList;
    const fh = entityList.find((e) => e.entityTypeShortName === "FH");
    const sh = entityList.find((e) => e.entityTypeShortName === "SH");
    setisFHJourneyEmpty(!fh?.kycApplicationWorkflowDTOList?.length);
    setisSHJourneyEmpty(!sh?.kycApplicationWorkflowDTOList?.length);
  }

  useEffect(() => {
    //get widget info
    getApplicationDetails();
    getLookupData("skInternal").then(
      (res) => {
        if (res != null) sessionStorage.setItem("skInternal", res);
      },
      (error) => {},
    );
  }, []);

  /**
   * To Check current holder ckyc already verified or not
   */
  useEffect(() => {
    const workflowList =
      applicationContext.currentHolder?.kycApplicationWorkflowDTOList;

    if (workflowList == null || workflowList.length === 0) {
      setCkycValueFetch(true);
    } else {
      setCkycValueFetch(false);
    }
  }, [applicationContext.currentHolder]);

  /**
   * when ever widget data changed then hold on the current form data object
   * @param {object} formData current widget form date
   */
  const handleFormDataChange = (formData) => {
    setCurrentFormData(formData);
  };

  const handleWidgetChange = (newWidget, WidgetList) => {
    setLastChangedType("Widget");
    var widgetAlertMessageDTO = getAlertMessageToWidgetChange(newWidget);
    setWidgetList(WidgetList);
    //if form mode is disabled then move to the next widget
    if (
      disableForm ||
      saveAlertNotRequiredForTheWidget(
        applicationContext.currentWidget,
        widgetAlertMessageDTO.showAlert,
      )
    ) {
      applicationContext.setCurrentWidget(newWidget);
    } else if (widgetAlertMessageDTO.showAlert) {
      setIsShowWidgetAlert(widgetAlertMessageDTO.showAlert);
      setWidgetMessageToShow(widgetAlertMessageDTO.message);
    }
    //else check new widget not equal to old one then show alert
    else if (
      applicationContext.currentWidget &&
      newWidget &&
      applicationContext.currentWidget.widgetShortName !==
        newWidget.widgetShortName
    ) {
      setMoveToWidgetOrHolder(newWidget);
      setIsWidgetAlertOpen(true);
    }
  };

  /**
   * Check save alert required for then given widget
   * @param {object} widget The
   * @returns
   */
  const saveAlertNotRequiredForTheWidget = (widget, showAlert) => {
    if (showAlert) {
      return false;
    } else if (
      widget &&
      indexOf(alertNotRequiredWidgetList, widget.widgetShortName) !== -1
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleHolderChange = (newHolder, WidgetList) => {
    setClicked(false);
    setLastChangedType("Holder");
    setWidgetList(WidgetList);
    //if form mode is disabled then move to the next Holder and if its not still check ckyc,then move to the next holder
    if (
      disableForm ||
      saveAlertNotRequiredForTheWidget(applicationContext.currentWidget, false)
    ) {
      applicationContext.setCurrentHolder(newHolder);
    }
    //else check new holder not equal to old one then show alert
    else if (
      applicationContext.currentHolder &&
      newHolder &&
      applicationContext.currentHolder.entityTypeShortName !==
        newHolder.entityTypeShortName
    ) {
      setMoveToWidgetOrHolder(newHolder);
      //if there is no ckyc verification done ,then we dont need to save
      if (
        (applicationContext.currentHolder.entityTypeShortName == "SH" &&
          !isSHJourneyEmpty) ||
        (applicationContext.currentHolder.entityTypeShortName == "FH" &&
          !isFHJourneyEmpty)
      ) {
        setIsWidgetAlertOpen(true);
        setSwitchHolderWithoutSave(false);
      } else {
        setIsWidgetAlertOpen(false);
        setSwitchHolderWithoutSave(true);
        applicationContext.setCurrentHolder(newHolder);
      }
    }
  };

  /**
   * Based on the user response move or not move to the next widget
   * @param {string} response alert message response
   * @param {object} nextObject next widget to move
   * @returns
   */
  const moveToNextWidgetOrHolder = (response, nextObject) => {
    // user select cancel then don't move to next widget
    if (response === AlertResponseEnum.Cancel) {
      return;
    } else if (response === AlertResponseEnum.DontSave) {
      setCurrentObject(nextObject);
    } else if (response === AlertResponseEnum.Save) {
      setShowLoading(true);
      saveWidgetToDraft(currentFormData).then(
        (response) => {
          setShowLoading(false);
          setCurrentObject(nextObject);
        },
        (error) => {
          setShowLoading(false);
        },
      );
    }
  };

  /**
   * Set the current widget or holder based on the change type
   * @param {object} currentFormData   nextObject
   */
  function setCurrentObject(nextObject) {
    if (lastChangedType === "Widget") {
      applicationContext.setCurrentWidget(nextObject);
    } else {
      setTimeout(() => {
        applicationContext.setCurrentHolder(nextObject);
      }, 5);
      applicationContext.setCurrentWidget(null);
    }
  }

  /** save widget data and update in the store */
  const saveWidgetToDraft = (data) => {
    return saveWidgetDataToDraft(
      data,
      applicationContext.currentHolder,
      applicationContext.currentWidget,
      widgetList || [],
      applicationContext.currentWidget.widgetName,
    );
  };

  /* Trigger the support Modal */
  function openSuppport(e) {
    e.preventDefault();
    setIsSupportModalOpen(true);
  }

  const getAlertMessageToWidgetChange = (movingTo) => {
    let messageDTO = { message: "", showAlert: false };

    //check moving widget if it is preview and other process are not completed the show error
    if (
      applicationDTO &&
      isKycProcessCompleted !== null &&
      isKycProcessCompleted === false &&
      movingTo.widgetShortName === WidgetEnum.PVIEWCKYC
    ) {
      if (applicationDTO && applicationDTO.kycAccountTypeShortName === "JA") {
        messageDTO.message =
          "Please fill and complete all the details of both first holder and second holder to view the preview";
        messageDTO.showAlert = true;
      } else {
        messageDTO.message =
          "Please fill and complete all the details to view the preview";
        messageDTO.showAlert = true;
      }
    } else if (
      applicationDTO &&
      applicationDTO.kycCompleted !== null &&
      applicationDTO.kycCompleted === false &&
      movingTo.widgetShortName === WidgetEnum.ESIGNTC
    ) {
      messageDTO.message =
        "e-sign will be available only on completing “Preview and complete KYC” step";
      messageDTO.showAlert = true;
    }

    return messageDTO;
  };

  function getHeaderText() {
    let headerText = "";

    //for admin view and workflow as ckyc then show the workflow remarks
    if (
      applicationContext &&
      applicationContext.currentHolder &&
      applicationContext.currentHolder.workflowRemarksJson &&
      applicationContext.currentHolder.workflowRemarksJson !== ""
    ) {
      var workflowRemarksDTO = JSON.parse(
        applicationContext.currentHolder.workflowRemarksJson,
      );
      if (workflowRemarksDTO) {
        headerText =
          " (CT:" +
          workflowRemarksDTO.constituentType +
          "; AHT:" +
          workflowRemarksDTO.accountHolderType +
          ")";
      }
    }

    return headerText;
  }

  const { getWidgetDTOList } = ApplicationDataHelper();
  const [isShowThanksMsg, setIsShowThanksMsg] = useState(false);

  function showThankYouMessage(profileStatusType, response) {
    if (profileStatusType) {
      if (
        profileStatusType === ProfileStatusTypeEnum.Video ||
        profileStatusType === ProfileStatusTypeEnum.ESign
      ) {
        var showThanksMsg = checkAllActivityCompleted(response);
        setIsShowThanksMsg(showThanksMsg);
      }
    }
  }

  function checkAllActivityCompleted(applicationDTO) {
    var result = true;

    for (
      let index = 0;
      index < applicationDTO.kycApplicationEntityDTOList.length;
      index++
    ) {
      const kycApplicationEntityDTO =
        applicationDTO.kycApplicationEntityDTOList[index];
      if (
        !checkAllActivityCompletedByHolder(
          applicationDTO,
          kycApplicationEntityDTO.entityTypeShortName,
        )
      ) {
        return false;
      }
    }

    return true;
  }

  function checkAllActivityCompletedByHolder(applicationDTO, holderType) {
    var widgetList = getWidgetDTOList(applicationDTO, holderType);
    if (checkEsignCompleted(widgetList) && checkVideoKycCompleted(widgetList)) {
      return true;
    } else {
      return false;
    }
  }

  function checkEsignCompleted(widgetList) {
    var widgetCompleted = false;
    if (widgetList) {
      let widget = find(
        widgetList,
        (widget) => widget.widgetShortName === WidgetEnum.ESIGNTC,
      );
      if (widget && widget.status === "Completed") {
        widgetCompleted = true;
      }
    }
    return widgetCompleted;
  }

  function checkVideoKycCompleted(widgetList) {
    var widgetCompleted = false;
    if (widgetList) {
      let widget = find(
        widgetList,
        (widget) => widget.widgetShortName === WidgetEnum.VIDEOKYC,
      );
      if (widget) {
        var videoKycDTO = JSON.parse(widget.widgetDataJson);
        if (
          widget.status === "Completed" ||
          (videoKycDTO.applicationStatus &&
            videoKycDTO.applicationStatus.toLowerCase() ===
              VideoKYCStatusEnum.Verified.toLowerCase())
        ) {
          widgetCompleted = true;
        }
      } else {
        widgetCompleted = true;
      }
    }
    return widgetCompleted;
  }

  /**
   * prepare ckycDetailDTO and check ckyc
   * @param {} e
   */
  function prepareAndGetCkycDetails(e) {
    if (e) {
      e.preventDefault();
    }
    if (clicked == false) {
      setClicked(true);
      getCKYCDetails(generateCKYCDetailDTO()).then(
        (res) => {
          setClicked(false);
          if (res.errorDescription && res.errorDescription.trim() !== "") {
            setShowCsplAlertModal(true);
            setDynamicMessage(res.errorDescription);
          } else {
            setCkycFlow(true);
            setTriggerCkycOtpResponse(res);
          }
        },
        (error) => {
          setClicked(false);
          setShowCsplAlertModal(true);
          setDynamicMessage(error);
        },
      );
    }
  }

  /**
   *
   * @returns generate request body to check ckyc
   */
  function generateCKYCDetailDTO() {
    const ckycDetailInputDTO = applicationDTO.kycApplicationEntityDTOList.find(
      (kycApplicationEntityDTO) => {
        return (
          kycApplicationEntityDTO.entityTypeShortName ===
          applicationContext.currentHolder.entityTypeShortName
        );
      },
    );
    const applicationEntityDetailDTO = {
      encryptedMode: sessionStorage.getItem(SessionKeyEnum.EncryptedMode),
      panNumber: ckycDetailInputDTO.panNumber,
      mobile: ckycDetailInputDTO.mobileNo,
      holderType: ckycDetailInputDTO.entityTypeShortName,
      kycApplicationId: sessionStorage.getItem(SessionKeyEnum.KycApplicationId),
    };
    return applicationEntityDetailDTO;
  }

  function verifyOTPDTO(otpString, triggerCkycOtpResponse) {
    const ckycDetailInputDTO = applicationDTO.kycApplicationEntityDTOList.find(
      (kycApplicationEntityDTO) => {
        return (
          kycApplicationEntityDTO.entityTypeShortName ===
          applicationContext.currentHolder.entityTypeShortName
        );
      },
    );
    const applicationEntityDetailDTO = {
      encryptedMode: sessionStorage.getItem(SessionKeyEnum.EncryptedMode),
      kycApplicationId: sessionStorage.getItem(SessionKeyEnum.KycApplicationId),
      panNumber: ckycDetailInputDTO.panNumber,
      mobile: ckycDetailInputDTO.mobileNo,
      holderType: ckycDetailInputDTO.entityTypeShortName,
      otp: otpString,
      requestId: triggerCkycOtpResponse.requestId,
    };
    return applicationEntityDetailDTO;
  }

  function resendOTPDTO(requestId) {
    const ckycDetailInputDTO = applicationDTO.kycApplicationEntityDTOList.find(
      (kycApplicationEntityDTO) => {
        return (
          kycApplicationEntityDTO.entityTypeShortName ===
          applicationContext.currentHolder.entityTypeShortName
        );
      },
    );
    const applicationEntityDetailDTO = {
      kycApplicationId: sessionStorage.getItem(SessionKeyEnum.KycApplicationId),
      panNumber: ckycDetailInputDTO.panNumber,
      mobile: ckycDetailInputDTO.mobileNo,
      holderType: ckycDetailInputDTO.entityTypeShortName,
      requestId: requestId,
    };
    return applicationEntityDetailDTO;
  }

  /**
   * to verify otp to check ckyc
   * @param {*} otp
   */
  const handleOtpSubmit = async (otp, triggerCkycOtpResponse) => {
    setIsButtonDisable(true);
    setClicked(true);
    try {
      const res = await verifyOTP(verifyOTPDTO(otp, triggerCkycOtpResponse));
      if (!res.errorDescription && res.errorDescription.trim() === "") {
        if (res.message === "CKYC downloaded successfully") {
          const result = await getApplicationDetails();

          setClicked(false);

          setCkycFlow(false);

          const entityList = result?.kycApplicationEntityDTOList || [];

          entityList.forEach((entity) => {
            entity?.kycApplicationWorkflowDTOList?.forEach((workflow) => {
              if (workflow.workflowDisplayName === "CKYC") {
                workflow?.widgetDTOList?.forEach((widget) => {
                  if (widget.widgetShortName === "PERSONALINFO") {
                    const widgetData = JSON.parse(widget.widgetDataJson);

                    const isDifferentlyAbled =
                      widgetData?.keyPersonalInfoDTO?.isDifferentlyAbled;

                    if (!isDifferentlyAbled || isDifferentlyAbled === "") {
                      setDynamicMessage(
                        "Disability Details not Recieved from Cersai, Please Complete the disability fields to Proceed.",
                      );
                      setButtonText("OK");
                      setShowCsplAlertModal(true);
                    }
                  }
                });
              }
            });
          });

          //setOtpMessage(res.message);
          //setOtpMessageType("success")
        } else {
          setIsButtonDisable(false);
          setOtpMessage(res.message);
          setOtpMessageType("error");
        }
      } else {
        setCkycFlow(false);
        setShowCsplAlertModal(true);
        setDynamicMessage(res.errorDescription);
      }
    } catch (error) {
      setIsButtonDisable(false);
      setClicked(false);
      setCkycFlow(true);
      setOtpMessage(error);
      setOtpMessageType("error");
    } finally {
      setIsButtonDisable(false);
      setClicked(false);
    }
  };

  /**
   *  handle resend otp
   * @param {*} otp
   */
  const handleResendOTP = () => {
    setClicked(true);
    resendOTP(resendOTPDTO(triggerCkycOtpResponse.requestId)).then(
      (res) => {
        setClicked(false);
        if (!res.errorDescription && res.errorDescription.trim() === "") {
          if (
            res.message ===
              "Resend OTP Option enable post 90 sec from the first request." ||
            res.message.includes(
              "Resend OTP Sent successfully to registered Mobile number",
            )
          ) {
            setCkycFlow(true);
            setOtpMessage(res.message);
            setOtpMessageType("success");
          } else {
            setOtpMessage(res.message);
            setOtpMessageType("error");
          }
        } else {
          setCkycFlow(false);
          setShowCsplAlertModal(true);
          setDynamicMessage(res.errorDescription);
        }
      },
      (error) => {
        setClicked(false);
        setCkycFlow(true);
      },
    );
  };

  /**
   *  handle resend otp
   * @param {*} otp
   */
  const getAadharDetailsToProceed = () => {
    setIsLoadingData(true);
    onSwitchToAdhaar();
  };

  /* Switching to Aadhaar */
  function onSwitchToAdhaar() {
    getAadharDetails(
      sessionStorage.getItem(SessionKeyEnum.KycApplicationId),
      applicationContext.currentHolder.entityTypeShortName,
    ).then(
      (res) => {
        getApplicationDetails();
        setClicked(false);
        setCkycFlow(false);
      },
      (error) => {
        setClicked(false);
      },
    );
  }

  /**
   * if there is no ckyc ,then proceed to aadhar
   */
  const handleProceed = () => {
    setClicked(true);
    setIsLoadingData(true);
    onSwitchToAdhaar();
    setShowCsplAlertModal(false);
  };

  /** to call only on change of holder without workflow*/
  useEffect(() => {
    if (switchHolderWithoutSave) {
      moveToNextWidgetOrHolder(
        AlertResponseEnum.DontSave,
        applicationContext.currentHolder,
      );
    }
  }, [switchHolderWithoutSave]);

  /**
   * clear the message after 5 seconds
   */
  useEffect(() => {
    if (otpMessage) {
      const timer = setTimeout(() => {
        setOtpMessage("");
        setOtpMessageType("");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [otpMessage]);

  /**
   * clear the message after 5 seconds
   */
  useEffect(() => {
    if (InitialCkycTrigger) {
      prepareAndGetCkycDetails();
    }
  }, [InitialCkycTrigger]);

  return (
    <>
      {/* Styles Component in Layout.js */}
      <section className="react_mainlayout">
        {/* Support Alert */}
        <AlertModal
          isModalOpen={isSupportModalOpen}
          setIsModalOpen={setIsSupportModalOpen}
          theme={true}
          type={NONE}
        >
          <Support
            isModalOpen={isSupportModalOpen}
            setIsModalOpen={setIsSupportModalOpen}
          />
        </AlertModal>

        {showKYCApplicationExpired && (
          <AlertModal
            isModalOpen={showKYCApplicationExpired}
            setIsModalOpen={setShowKYCApplicationExpired}
            type={NONE}
            title={"modal.alertModalTitle"}
          >
            <div>
              {t("welcome.kycApplicationExpired", {
                krnNo: expiredKYCApplication.kycAppRefNo,
              })}
            </div>
          </AlertModal>
        )}
        {!showKYCApplicationExpired && (
          <div className="react_body">
            <Banner
              currentFormData={currentFormData}
              saveWidgetToDraft={saveWidgetToDraft}
            />
            {isLoadingData === false && isCkycValueFetch && (
              <div className="text-center">
                <div className="col-xxl-3 col-xl-4 col-lg-5 col-md-5 col-sm-6 col-11 mb-4 mx-auto getCkycDetails getadhaardetails_two">
                  <a
                    onClick={(e) => {
                      if (applicationContext.mode === VIEW_MODE) {
                        e.preventDefault();
                        return;
                      }
                      prepareAndGetCkycDetails(e);
                    }}
                    className={`btn shadow-none getadhaardetails_btn ${applicationContext.mode === VIEW_MODE ? "disabled" : ""}`}
                    style={{
                      pointerEvents:
                        applicationContext.mode === VIEW_MODE ? "none" : "auto",
                      opacity: applicationContext.mode === VIEW_MODE ? 0.6 : 1,
                      cursor:
                        applicationContext.mode === VIEW_MODE
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    <CsplLabel label="mainAppLayout.getCKycDetails" />
                  </a>
                  {clicked && (
                    <CsplBackDropLoading
                      showLoading={clicked}
                      zIndex={200001}
                    ></CsplBackDropLoading>
                  )}
                  <div className="mt-3">
                    <span className="getadhaardetails_intruc">
                      <CsplLabel label="mainAppLayout.clickToGetCkycDetails"></CsplLabel>
                    </span>
                  </div>
                </div>
              </div>
            )}

            <CsplAlertModal
              show={showCsplAlertModal}
              onProceed={handleProceed}
              message={dynamicMessage}
              buttonText={buttonText}
            />

            {isLoadingData}
            {isLoadingData && (
              <CsplBackDropLoading
                showLoading={isLoadingData}
              ></CsplBackDropLoading>
            )}
            {isLoadingData === false && (
              <section>
                {/* SideBar */}
                <SideBar id="menubar">
                  <Holder
                    onWidgetChange={handleWidgetChange}
                    onHolderChange={handleHolderChange}
                  ></Holder>
                </SideBar>

                {/* Main Body Content */}
                <Content>
                  <div className="header_panel">
                    {applicationContext.currentHolder && (
                      <>
                        <span className="">
                          {" "}
                          {applicationContext.currentHolder.entityTypeName}{" "}
                        </span>{" "}
                        {/*  -{" "} */}
                        <span className="fst-italic font-size-13">
                          <span className="text-dark">
                            {" "}
                            {t("mainAppLayout.applicationId")}{" "}
                          </span>
                          <span> {applicationDTO.kycAppRefNo} </span>

                          {applicationContext.mode &&
                            applicationContext.mode === VIEW_MODE &&
                            applicationContext.currentHolder &&
                            applicationContext.currentHolder
                              .workflowRemarksJson &&
                            applicationContext.currentHolder
                              .workflowRemarksJson !== "" && (
                              <span>{getHeaderText()}</span>
                            )}

                          {applicationContext.mode &&
                            applicationContext.mode !== VIEW_MODE && (
                              <span
                                className="supportIcon ms-1 cursor_pointer"
                                onClick={(event) => openSuppport(event)}
                              ></span>
                            )}
                        </span>
                      </>
                    )}
                  </div>
                  <CsplBackDropLoading
                    showLoading={showLoading}
                  ></CsplBackDropLoading>
                  {!TACChecked && !disableForm && (
                    <KycGuideModal
                      getAutoTriggerConfirmation={getAutoTriggerConfirmation}
                      isTacChecked={!TACChecked}
                      setischecked={setTACChecked}
                    />
                  )}

                  <div>
                    {isCkycFlow && (
                      <OtpModal
                        show={setCkycFlow}
                        onClose={() => setModalVisible(false)}
                        onSubmit={(otpString) =>
                          handleOtpSubmit(otpString, triggerCkycOtpResponse)
                        }
                        onResendOtp={handleResendOTP}
                        onGetAadharDetails={getAadharDetailsToProceed}
                        messageText={otpMessage}
                        messageType={otpMessageType}
                        setIsButtonDisable={setIsButtonDisable}
                        isButtonDisable={isButtonDisable}
                      />
                    )}
                  </div>

                  <WidgetManager
                    onChange={setCurrentFormData}
                    showLoading={setShowLoading}
                    getApplicationDetails={getApplicationDetails}
                    setIsLoadingData={setIsLoadingData}
                  ></WidgetManager>
                  {isWidgetAlertOpen && (
                    <WidgetChangeAlertModal
                      isModalOpen={isWidgetAlertOpen}
                      setIsModalOpen={setIsWidgetAlertOpen}
                      data={moveToWidgetOrHolder}
                      currentWidget={applicationContext.currentWidget}
                      onClose={moveToNextWidgetOrHolder}
                    ></WidgetChangeAlertModal>
                  )}

                  {isShowWidgetAlert && (
                    <AlertModal
                      isModalOpen={isShowWidgetAlert}
                      setIsModalOpen={setIsShowWidgetAlert}
                      type={OK}
                      title={"modal.alertModalTitle"}
                    >
                      {widgetMessageToShow}
                    </AlertModal>
                  )}
                </Content>
              </section>
            )}
            {isShowThanksMsg && (
              <AlertModal
                title="Thank you...!"
                isModalOpen={isShowThanksMsg}
                setIsModalOpen={setIsShowThanksMsg}
                type={OK}
              >
                <div>{t("message.thankYouAlert")}</div>
              </AlertModal>
            )}
          </div>
        )}
      </section>
    </>
  );
}

export default MainAppLayout;
